







































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
import commonService from '@/services/common-services';
import u from '@/utility/utility';
@Component({
    components: {
        Loading
    },
})
export default class DetailProduct extends Vue {
    @Prop({ type: String, default: '' }) readonly itemUrl!: string;
    private isLoading = false;
    private selectedProduct: any = null;
    private selectedQuantity: number = 1;
    private mainImage: string = '';
    private itemUrlLocal: string = '';
    private reactivityCounter: number = 0;
    private isTranslate: boolean = false;
    get rate() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get productPlatform(): 'TAOBAO' | 'TMALL' | '1688' | null {
        if (!this.selectedProduct) {
            return null;
        }

        if (this.selectedProduct.platform === '1688') {
            return '1688';
        } else if (this.selectedProduct.platform === 'taobao') {
            return 'TAOBAO';
        } else if (this.selectedProduct.platform === 'tmall') {
            return 'TMALL';
        }

        return null;
    }

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }

    get proxiedMainImage(): string {
        return this.proxyImage(this.mainImage);
    }

    get proxiedDescription(): string {
        if (!this.selectedProduct || !this.selectedProduct.description) {
            return '';
        }

        // Replace all img src URLs with proxied versions
        // Also handles protocol-relative URLs like //img.alicdn.com/...
        return this.selectedProduct.description.replace(
            /(<img[^>]+src=")([^"]+)(")/g,
            (match, prefix, srcUrl, suffix) => {
                if (srcUrl.startsWith('//')) {
                    srcUrl = 'https:' + srcUrl;
                }
                return `${prefix}${this.proxyImage(srcUrl)}${suffix}`;
            }
        );
    }

    // Computed property for available options from SKUs
    get availableOptions() {
        if (!this.selectedProduct || !this.selectedProduct.skus) {
            return [];
        }

        const optionsMap: { [key: string]: any } = {};

        // Extract all unique options from SKUs
        this.selectedProduct.skus.forEach(sku => {
            if (sku.options) {
                sku.options.forEach(option => {
                    if (!optionsMap[option.name]) {
                        optionsMap[option.name] = {
                            name: option.name,
                            nameEn: option.nameEn,
                            values: []
                        };
                    }

                    // Check if this value already exists
                    const existingValue = optionsMap[option.name].values.find(v =>
                        v.value === option.value
                    );

                    if (!existingValue) {
                        optionsMap[option.name].values.push({
                            value: option.value,
                            valueEn: option.valueEn,
                            isActive: false
                        });
                    }
                });
            }
        });

        return Object.values(optionsMap);
    }

    // Computed property để track selected options cho reactivity
    get selectedOptions() {
        // Force dependency on reactivityCounter to ensure updates
        const counter = this.reactivityCounter;

        const selected: { [key: string]: string } = {};


        // Force reactivity by accessing each value's isActive property explicitly
        this.availableOptions.forEach(optionGroup => {

            // Explicitly access each value's isActive to ensure Vue tracks the dependencies
            optionGroup.values.forEach(value => {
                const isActive = value.isActive; // Force Vue to track this dependency
                if (isActive) {
                    selected[optionGroup.name] = value.value;
                }
            });
        });

        return selected;
    }

    private getSelectedSkuBasedOnOptions() {
        if (!this.selectedProduct || !this.selectedProduct.skus) {
            return null;
        }

        // Use computed selectedOptions for better reactivity
        const selectedOptions = this.selectedOptions;

        // Debug log

        // If no options selected, return first SKU
        if (Object.keys(selectedOptions).length === 0) {
            return this.selectedProduct.skus[0];
        }

        // Find SKU that matches selected options (relaxed matching)
        const matchingSku = this.selectedProduct.skus.find(sku => {
            if (!sku.options || sku.options.length === 0) {
                return false;
            }


            // Check if all selected options match this SKU
            let allMatch = true;
            for (const [optionName, optionValue] of Object.entries(selectedOptions)) {
                const skuOption = sku.options.find(opt => opt.name === optionName && opt.value === optionValue);
                if (!skuOption) {
                    allMatch = false;
                    break;
                }
            }

            return allMatch;
        });

        return matchingSku || this.selectedProduct.skus[0];
    }

    get currentPrice() {
        if (!this.selectedProduct) {
            return 0;
        }

        const toNumber = (value: any): number => {
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : 0;
        };

        const productSkus = Array.isArray(this.selectedProduct.skus) ? this.selectedProduct.skus : [];
        const hasSkuOptions = productSkus.some(sku => Array.isArray(sku.options) && sku.options.length > 0);
        const hasSkuPrice = productSkus.some(sku => toNumber(sku.price) > 0);
        const shouldUseSkuPrice = hasSkuOptions && hasSkuPrice;

        // For 1688 products with volume pricing
        if (this.selectedProduct.quote_type === 'by_volume' && this.selectedProduct.price_range) {
            const volumePrice = this.getPriceByQuantity1688(this.selectedQuantity);
            return volumePrice;
        }

        // Auto-detect SKU pricing even when quote_type is returned incorrectly.
        if (shouldUseSkuPrice || this.selectedProduct.quote_type === 'by_sku') {
            const selectedSku = this.getSelectedSkuBasedOnOptions();
            if (selectedSku) {
                const skuPrice = toNumber(selectedSku.price);
                if (skuPrice > 0) {
                    return skuPrice;
                }
            }

            const firstValidSku = productSkus.find(sku => toNumber(sku.price) > 0);
            if (firstValidSku) {
                const skuPrice = toNumber(firstValidSku.price);
                return skuPrice;
            }
        }

        // For 1688 products with direct pricing
        if (this.selectedProduct.quote_type === 'direct' && this.selectedProduct.price_range && this.selectedProduct.price_range.length > 0) {
            const directPrice = toNumber(this.selectedProduct.price_range[0].price);
            return directPrice;
        }

        // Fallback to base price
        const fallbackPrice = toNumber(this.selectedProduct.price);
        return fallbackPrice;
    }

    // Updated function for 1688 price calculation
    private getPriceByQuantity1688(quantity: number): number {
        if (!this.selectedProduct.price_range || this.selectedProduct.price_range.length === 0) {
            return this.selectedProduct.price || 0;
        }

        const priceRanges = this.selectedProduct.price_range;
        // Sort by moq descending to find the appropriate price tier
        const sortedRanges = [...priceRanges].sort((a, b) => b.moq - a.moq);

        // Find the appropriate price tier
        for (const range of sortedRanges) {
            if (quantity >= range.moq) {
                return range.price;
            }
        }

        // If no tier matches, return the lowest tier price
        return priceRanges[0].price;
    }

    // Computed property for price range display
    get priceRangeDisplay(): string {
        if (!this.selectedProduct.price_range || this.selectedProduct.price_range.length === 0) {
            return '';
        }

        // Sort by moq ascending for display
        const sortedRanges = [...this.selectedProduct.price_range].sort((a, b) => a.moq - b.moq);

        return sortedRanges.map(range => {
            const price = range.price;
            return `≥${range.moq}cái: ${price}¥`;
        }).join(' | ');
    }

    get currentPriceVND() {
        return (this.currentPrice * this.rate).toLocaleString('vi-VN');
    }
    get minPrice() {
        if (this.selectedProduct && this.selectedProduct.skus && this.selectedProduct.skus.length > 0) {
            const prices = this.selectedProduct.skus.map(sku => sku.price
            ).filter(p => !isNaN(p) && p > 0);
            return prices.length > 0 ? Math.min(...prices) : (this.selectedProduct.price || 0);
        }
        return (this.selectedProduct && this.selectedProduct.price) || 0;
    }

    get maxPrice() {
        if (this.selectedProduct && this.selectedProduct.skus && this.selectedProduct.skus.length > 0) {
            const prices = this.selectedProduct.skus.map(sku => sku.price
            ).filter(p => !isNaN(p) && p > 0);
            return prices.length > 0 ? Math.max(...prices) : (this.selectedProduct.price || 0);
        }
        return (this.selectedProduct && this.selectedProduct.price) || 0;
    }
    @Watch('isTranslate')
    async onIsTranslateChange() {
        if (this.itemUrlLocal) {
            await this.loadProductDetail();
        }
    }

    @Watch('$route.query.itemUrl')
    async onRouteItemUrlChange(newVal: string, oldVal: string) {
        if (newVal && newVal !== oldVal) {
            this.itemUrlLocal = newVal;
            this.selectedProduct = null;
            await this.loadProductDetail();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    async created() {
        this.isLoading = true;
        if (!this.rate) {
            await this.getRate();
        }
        // Ưu tiên lấy itemUrl từ prop nếu có
        this.itemUrlLocal = this.itemUrl || (this.$route.query.itemUrl as string) || '';
        if (this.itemUrlLocal) {
            await this.loadProductDetail();
        }

        // Set minimum quantity for 1688 products
        if (this.selectedProduct && this.selectedProduct.moq && this.selectedProduct.moq > 1) {
            this.selectedQuantity = this.selectedProduct.moq;
        }

        // Load similar products from previous search context
        try {
            const ctxStr = localStorage.getItem('similar_products_context');
            if (ctxStr) {
                const ctx = JSON.parse(ctxStr);
                this.similarProducts = (ctx.items || []).filter((p: any) => p.miId !== ctx.currentMiId);
                this.similarSearchTerm = ctx.searchTerm || '';
            }
        } catch (e) { /* ignore */ }

        this.isLoading = false;
    }

    private async loadProductDetail() {
        this.isLoading = true;
        const response = await cartServices.detailProduct(this.itemUrlLocal, this.isTranslate);
        // Backend trả về: { message: 'Success', data: <normalized product> }
        const productData = response && response.data && (
            response.data.data || response.data
        );
        if (productData && productData.success) {
            this.selectedProduct = productData;
            if (this.selectedProduct.img_urls && this.selectedProduct.img_urls.length > 0) {
                this.mainImage = this.selectedProduct.img_urls[0];
            } else {
                this.mainImage = '';
            }
            
            if(this.selectedProduct.detail_url) {
                this.itemUrlLocal = this.selectedProduct.detail_url;
            } else if (this.selectedProduct.final_url) {
                this.itemUrlLocal = this.selectedProduct.final_url;
            }

            // Initialize isActive for option values
            this.$nextTick(() => {
                if (this.availableOptions) {
                    this.availableOptions.forEach(optionGroup => {
                        if (optionGroup.values) {
                            optionGroup.values.forEach(value => {
                                this.$set(value, 'isActive', false);
                            });
                        }
                    });
                }
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Không thể tải chi tiết sản phẩm. Vui lòng cài đặt extension để lên đơn.',
            });
            this.selectedProduct = null;
        }
        this.isLoading = false;
    }

    private changeMainImage(image) {
        this.mainImage = image;
    }

    private handleImageError(event) {
        // Fallback khi ảnh không load được
        const img = event.target;
        // Sử dụng ảnh placeholder hoặc ảnh mặc định
        img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkPDtCDhuJdhbmggYeG6v24gY+G6q3UgdOG6jWkg4bm6YW5oPC90ZXh0Pgo8L3N2Zz4K';
    }

    private selectAttribute(optionGroup, selectedValue) {

        // Use Vue.set to ensure reactivity for each value
        optionGroup.values.forEach((value, index) => {
            const newActiveState = value === selectedValue;

            // Use $set with the full path to ensure Vue tracks the change
            this.$set(optionGroup.values[index], 'isActive', newActiveState);
        });


        // Force Vue to re-evaluate computed properties by updating a reactive property
        // We'll add a temporary reactive counter to force updates
        if (!this.reactivityCounter) {
            this.$set(this, 'reactivityCounter', 0);
        }
        this.reactivityCounter++;

        // Update main image if the selected option has an associated image
        const selectedSku = this.getSelectedSkuBasedOnOptions();
        if (selectedSku && selectedSku.img_url) {
            this.mainImage = selectedSku.img_url;
        }


        // Force reactivity update for computed properties
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }

    private getSelectedSku() {
        const selectedOptions: string[] = [];

        // Use the computed selectedOptions for consistency
        for (const [optionName, optionValue] of Object.entries(this.selectedOptions)) {
            selectedOptions.push(`${optionName}: ${optionValue}`);
        }

        return selectedOptions;
    }

    private increaseQuantity() {
        this.selectedQuantity++;
        this.validateQuantity();
        // Force update giá khi thay đổi số lượng (đặc biệt cho 1688)
        if (this.selectedProduct && this.selectedProduct.quote_type === 'by_volume') {
            this.$forceUpdate();
        }
    }

    private decreaseQuantity() {
        if (this.selectedQuantity > 1) {
            this.selectedQuantity--;
        }
        this.validateQuantity();
        // Force update giá khi thay đổi số lượng (đặc biệt cho 1688)
        if (this.selectedProduct && this.selectedProduct.quote_type === 'by_volume') {
            this.$forceUpdate();
        }
    }

    private validateQuantity() {
        if (this.selectedQuantity < 1 || isNaN(this.selectedQuantity)) {
            this.selectedQuantity = 1;
        }

        // Check minimum order quantity for 1688
        if (this.selectedProduct && this.selectedProduct.moq && this.selectedQuantity < this.selectedProduct.moq) {
            this.selectedQuantity = this.selectedProduct.moq;
        }

        // Force update giá khi thay đổi số lượng (đặc biệt cho 1688)
        if (this.selectedProduct && this.selectedProduct.quote_type === 'by_volume') {
            this.$forceUpdate();
        }
    }

    private getSiteName(productData) {
        // Determine site based on quote_type and other indicators
        if (!productData) { return ''; }

        if (productData.platform === '1688') {
            return '1688';
        } else if (productData.platform === 'taobao') {
            return 'TAOBAO';
        } else if (productData.platform === 'tmall') {
            return 'TMALL';
        }

        return '';
    }

    private async getRate() {
        const result = await commonService.exchangeRate();
        if (result && result.status === 200 && result.data && result.data.data) {
            (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
            (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
        }
    }

    private openSimilarProduct(product: any) {
        let productUrl = product.link || product.url || '';
        const platform = (product.platform || '').toLowerCase();
        
        if (platform === 'taobao' || platform === 'tmall' || productUrl.includes('taobao.com') || productUrl.includes('tmall.com')) {
            if (product.miId) {
                try {
                    const parsedUrl = new URL(productUrl || `https://item.taobao.com/item.htm?id=${product.id}`);
                    parsedUrl.searchParams.set('miId', product.miId);
                    productUrl = parsedUrl.toString();
                } catch (e) {
                    productUrl = productUrl || `https://item.taobao.com/item.htm?id=${product.id}`;
                    if (!productUrl.includes('miId=')) {
                        productUrl += (productUrl.includes('?') ? '&' : '?') + `miId=${product.miId}`;
                    }
                }
            } else if (!productUrl && product.id) {
                productUrl = `https://item.taobao.com/item.htm?id=${product.id}`;
            }
        } else if (!productUrl && product.id) {
            if (platform === '1688' || platform === 'alibaba') {
                productUrl = `https://detail.1688.com/offer/${product.id}.html`;
            }
        }

        if (!productUrl) { return; }
        this.$router.push({
            name: 'detail-product-index',
            query: { itemUrl: productUrl },
        });
    }

    // getPriceByQuantity is effectively replaced by the logic within currentPrice computed property
    // If specific quantity-based pricing were to be re-introduced, this method would need new logic.
    // For now, currentPrice handles SKU-based price variations.

    private isBuyingNow = false;
    private similarProducts: any[] = [];
    private similarSearchTerm: string = '';
    private showDescription: boolean = false;

    private async addToCart() {
        if (!this.selectedProduct) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Sản phẩm không tồn tại.' });
            return;
        }

        const selectedSkuOptions = this.getSelectedSku();
        const hasMultipleOptions = this.availableOptions && this.availableOptions.length > 0;
        const selectedOptionsCount = Object.keys(this.selectedOptions).length;

        if (hasMultipleOptions && selectedOptionsCount < this.availableOptions.length) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Vui lòng chọn đầy đủ thuộc tính sản phẩm trước khi thêm vào giỏ hàng',
            });
            return;
        }

        if (this.currentPrice <= 0) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Giá sản phẩm không hợp lệ. Vui lòng chọn lại thuộc tính.'
            });
            return;
        }

        this.isLoading = true;

        // Lấy SKU được chọn
        const selectedSku = this.getSelectedSkuBasedOnOptions();

        let miId: string | null = null;
        if (this.itemUrlLocal) {
            try {
                const parsedUrl = new URL(this.itemUrlLocal);
                miId = parsedUrl.searchParams.get('miId');
            } catch (e) {
                const match = this.itemUrlLocal.match(/[?&]miId=([^&]+)/);
                if (match) {
                    miId = match[1];
                }
            }
        }

        const cartItem = {
            'ShopID': this.selectedProduct.shop_id,
            'ShopName': this.selectedProduct.shop_name || '',
            'Site': this.getSiteName(this.selectedProduct),
            'Note': '',
            'IsFragileGoods': 0,
            'IsFeeShip': 0,
            'Products': [
                {
                    'item_id': this.selectedProduct.id || this.selectedProduct.mpId,
                    'shop_id': this.selectedProduct.shop_id,
                    'shop_name': this.selectedProduct.shop_name || '',
                    'title_origin': this.selectedProduct.title,
                    'image_origin': this.mainImage,
                    'link_origin': this.itemUrlLocal,
                    'property': selectedSkuOptions.join('; '),
                    'quantity': this.selectedQuantity,
                    'price_origin': this.currentPrice,
                    'price_promotion': this.currentPrice,
                    'comment': '',
                    // Lưu Xadal SKU data cho chức năng add-to-cart Xadal sau này
                    'xadal_sku_id': selectedSku ? (selectedSku.mpSkuId || selectedSku.skuId) : null,
                    'xadal_mp_id': this.selectedProduct.mpId || this.selectedProduct.id,
                    'xadal_value_name': selectedSku ? selectedSku._xadal_valueName : null,
                    'xadal_source': this.selectedProduct.source_name || this.selectedProduct.platform,
                    'mi_id': miId,
                }
            ]
        };

        const result = await cartServices.cartAddItem(cartItem);
        this.isLoading = false;

        if (result && result.data.status === 200 && result.data.message === 'Success') {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đã thêm sản phẩm vào giỏ hàng. Bạn hãy nhấn vào Giỏ hàng để lên đơn nhé.',
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
                duration: 5000
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: (result && result.data && result.data.message) || 'Có lỗi trong quá trình thêm vào giỏ hàng, vui lòng liên hệ quản trị!',
            });
        }
    }

    private async buyNow() {
        if (this.isBuyingNow) return;
        this.isBuyingNow = true;

        const cartItem = this.buildCartItem();
        if (!cartItem) {
            this.isBuyingNow = false;
            return;
        }

        const result = await cartServices.cartAddItem(cartItem);
        console.log('[buyNow] cartAddItem result:', JSON.stringify(result && result.data));
        this.isBuyingNow = false;

        if (!result || result.data.status !== 200) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: (result && result.data && result.data.error) || 'Có lỗi khi thêm vào giỏ hàng.',
            });
            return;
        }

        // Thử các vị trí có thể chứa cart ID
        const cartId = (result.data.data && (result.data.data.ID || result.data.data.id)) || result.data.ID || result.data.id;
        console.log('[buyNow] cartId:', cartId, '| raw data:', JSON.stringify(result.data.data));

        if (cartId) {
            const cartResult = await cartServices.cartByIds(String(cartId));
            console.log('[buyNow] cartByIds result:', JSON.stringify(cartResult && cartResult.data));
            if (cartResult && cartResult.status === 200) {
                const rawCarts = cartResult.data.data || [];
                if (rawCarts.length > 0) {
                    const { Cart } = await import('@/models/cart');
                    const Product = require('@/models/product').Product;
                    const rate = this.rate;
                    const emitData = rawCarts.map((item: any) => {
                        const cart = new Cart();
                        cart.id = item.ID;
                        cart.shopId = item.ShopID;
                        cart.shopName = item.ShopName;
                        cart.site = item.Site;
                        cart.isChoose = true;
                        cart.products = (item.Products || []).map((prod: any) => {
                            const p = new Product();
                            p.id = prod.ID;
                            p.imageOrigin = prod.image_origin;
                            p.linkOrigin = prod.link_origin;
                            p.priceOrigin = prod.price_origin;
                            p.pricePromotion = prod.price_promotion;
                            p.priceOriginVND = p.priceOrigin * rate;
                            p.pricePromotionVND = p.pricePromotion * rate;
                            p.property = prod.property;
                            p.quantity = prod.quantity;
                            p.titleOrigin = prod.title_origin;
                            p.dataValue = prod.data_value;
                            p.itemId = prod.item_id;
                            p.amount = (prod.quantity || 1) * ((prod.price_promotion || prod.price_origin) * rate);
                            p.amountCN = (prod.quantity || 1) * (prod.price_promotion || prod.price_origin);
                            p.isChoose = true;
                            return p;
                        });
                        cart.amount = cart.products.reduce((val: number, p: any) => val + p.amount, 0);
                        return cart;
                    });

                    console.log('[buyNow] Navigating to cart-confirm-cart with', emitData.length, 'carts');
                    (window['getApp'] as any).$emit('SET_SELECTED_CART', emitData);
                    this.$router.push({ name: 'cart-confirm-cart' });
                    return;
                }
            }
        }

        // Fallback: không lấy được cartId
        console.warn('[buyNow] Could not get cartId or cart data, showing fallback');
        Vue.notify({
            group: 'foo',
            type: 'warn',
            title: 'Thông báo!',
            text: 'Đã thêm vào giỏ hàng. Vui lòng vào Giỏ hàng để đặt hàng.',
        });
    }

    private buildCartItem(): any {
        if (!this.selectedProduct) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Sản phẩm không tồn tại.' });
            return null;
        }
        const hasMultipleOptions = this.availableOptions && this.availableOptions.length > 0;
        const selectedOptionsCount = Object.keys(this.selectedOptions).length;
        if (hasMultipleOptions && selectedOptionsCount < this.availableOptions.length) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Vui lòng chọn đầy đủ thuộc tính sản phẩm.' });
            return null;
        }
        if (this.currentPrice <= 0) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Giá sản phẩm không hợp lệ. Vui lòng chọn lại thuộc tính.' });
            return null;
        }
        const selectedSkuOptions = this.getSelectedSku();
        const selectedSku = this.getSelectedSkuBasedOnOptions();
        return {
            'ShopID': this.selectedProduct.shop_id,
            'ShopName': this.selectedProduct.shop_name || '',
            'Site': this.getSiteName(this.selectedProduct),
            'Note': '',
            'IsFragileGoods': 0,
            'IsFeeShip': 0,
            'Products': [{
                'item_id': this.selectedProduct.id || this.selectedProduct.mpId,
                'shop_id': this.selectedProduct.shop_id,
                'shop_name': this.selectedProduct.shop_name || '',
                'title_origin': this.selectedProduct.title,
                'image_origin': this.mainImage,
                'link_origin': this.itemUrlLocal,
                'property': selectedSkuOptions.join('; '),
                'quantity': this.selectedQuantity,
                'price_origin': this.currentPrice,
                'price_promotion': this.currentPrice,
                'comment': '',
                'xadal_sku_id': selectedSku ? (selectedSku.skuId || selectedSku.mpSkuId) : null,
                'xadal_mp_id': this.selectedProduct.mpId || this.selectedProduct.id,
                'xadal_value_name': selectedSku ? selectedSku._xadal_valueName : null,
                'xadal_source': this.selectedProduct.source_name || this.selectedProduct.platform,
            }]
        };
    }
}
